<template>
  <div class="app-footer">
    <div class="app-footer__logo">
      <a href="/">
        <logo-icon />
      </a>
    </div>
    <ul class="app-footer__social">
      <li>
        <a href="//facebook.com/commercecohq">
          <facebook-icon />
        </a>
      </li>
      <li>
        <a href="//twitter.com/commercecohq">
          <twitter-icon />
        </a>
      </li>
      <li>
        <a href="//instagram.com/ecommerce">
          <instagram-icon />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import LogoIcon from 'static/assets/icons/LogoIcon.svg'
import FacebookIcon from 'static/assets/icons/FacebookIcon.svg'
import TwitterIcon from 'static/assets/icons/TwitterIcon.svg'
import InstagramIcon from 'static/assets/icons/InstagramIcon.svg'

export default {
  name: 'AppFooter',
  components: {
    FacebookIcon,
    TwitterIcon,
    InstagramIcon,
    LogoIcon,
  },
}
</script>

<style lang="sass" scoped>
@import '~styles/shared'

.app-footer
  background-color: #0f1d33
  margin: 0 auto
  padding: 33px 0 36px

  @include tablet
    display: flex
    justify-content: space-between
    align-items: center
    padding: 28px 22px 24px

.app-footer__logo
  text-align: center
  margin-bottom: 24px

  @include tablet
    margin-bottom: 0

  a
    cursor: initial

  svg
    fill: #616e85
    width: 130px
    cursor: pointer

    @include tablet
      width: 156px

    &:hover
      fill: #919fb8

.app-footer__social
  display: flex
  justify-content: center
  padding-right: 8px

  @include tablet
    padding-right: 0

  li
    margin: 0 11px

  svg
    width: 20px
    height: 20px
    fill: #616e85

    &:hover
      fill: #919fb8
</style>



// WEBPACK FOOTER //
// src/AppFooter.vue